import { render, staticRenderFns } from "./LegalNotices.vue?vue&type=template&id=1576bf6e&scoped=true"
import script from "./LegalNotices.vue?vue&type=script&lang=js"
export * from "./LegalNotices.vue?vue&type=script&lang=js"
import style0 from "./LegalNotices.vue?vue&type=style&index=0&id=1576bf6e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1576bf6e",
  null
  
)

export default component.exports